import PropTypes from 'prop-types';
import { ESTADOS, PROCESOS_ESPECIFICOS, TIPO_MONITOREOS } from 'constants/nombresCatalogos';
import { useEffect, useState, useRef, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Table, Button, Input, Checkbox, SelectTamanoPagina, Tooltip } from 'components';
import { DatePicker, Select, message, Spin } from 'antd';
import dayjs from 'dayjs';
import {
  getMonitoreosInternet,
  validarHallazgosByMoni,
  cancelMonitoring
} from 'actions/monitoreos.actions';
import { getPdfActa } from 'actions/pdf.actions';
import { selectMonitoreosInternetState } from 'selectors/monitoreosInternet.selector';
import { DOWNLOAD_TYPES } from 'constants/downloadTypes';
import { selectMenuState } from 'selectors/auth.selector';
import {
  DownloadOutlined,
  EyeOutlined,
  EditOutlined,
  CloseCircleOutlined,
  BellOutlined
} from '@ant-design/icons';
import {
  DATE_FORMAT_COLUMN_TABLE,
  DATE_FORMAT_DATE_PICKER,
  REGULAR_DATE_FORMAT
} from 'constants/dateFormat';
import { useDebounce } from 'hooks/useDebounce';
import { ModalPdf, DescargaPDF } from 'components/ModalPdf/ModalPdf';
import * as MensGrales from 'constants/MensajesGenerales';
import { filterList } from 'utils/filterList';
import { getFolioNumber, PREFIX_INTERNET } from 'utils/getFolioNumber';
import { getMenuPermissions } from 'utils/getMenuPermissions';
import {
  NOMBRE_MENU_INTERNET,
  NOMBRE_MENU_PERMISO_CAPTURAR,
  NOMBRE_MENU_PERMISO_EDITAR,
  NOMBRE_MENU_PERMISO_ELIMINAR,
  NOMBRE_MENU_PERMISO_NOTIFICAR,
  NOMBRE_MENU_PERMISO_VALIDAR
} from 'constants/menuNombres';
import { TIPO_INTERNET, PARCIALMENTE_NOTIFICADO, NOTIFICADO } from 'constants/notificarPartidos';
import { selectCatalogByName, selectCatalogs } from 'selectors/catalogos.selectors';
import { MONITOREOS_INTERNET } from 'constants/tipoMonitoreos';
import { PDF_INTERNET } from 'constants/pdfTypes';
import { downloadExcelMonitoreos } from 'actions/files.actions';
import { base64toBlob } from 'utils/file';
import { DescripcionEnlacesModal } from 'components/GeneracionEnlaces/DescripcionEnlacesModal';
import CancelModalMonitoring from 'components/CancelModalMonitoring/CancelModalMonitoring';
import ModalNotificarPartido from 'components/ModalNotificarPartido/ModalNotificarPartido';
import './TablaMonitoreo.scss';

import {
  HALLAZGO_VALIDADO,
  HALLAZGO_NO_VALIDADO,
  HALLAZGO_CANCELADO
} from 'constants/estatusHallazgos';

// MNI - Genera formatos PDF al validar
import { generarPDFMonitoreosValidacion } from 'services/monitoreos.service';
import { ModalFormularioMonitoreo } from './ModalFormularioMonitoreo/ModalFormularioMonitoreo';

const DEBOUNCE_TIME_FILTER = 2000;

export const TablaMonitoreo = ({ mainFilters, seleccion, onProcesarTodoChange }) => {
  const filtersRef = useRef({});
  const notificar = useRef({});
  const validar = useRef({});
  const [isFormModalVisible, setIsFormModalVisible] = useState(false);
  const [isModalPdfOpen, setIsModalPdfOpen] = useState(false);
  const [isMonitoreoId, setIsMonitoreoId] = useState(null);
  const [isHallazgoId, setIsHallazgoId] = useState(null);
  const [filters, setFilters] = useState({});
  const procesosEspe = useSelector(selectCatalogByName(PROCESOS_ESPECIFICOS));
  const estados = useSelector(selectCatalogByName(ESTADOS));
  const catMonitoreos = useSelector(selectCatalogByName(TIPO_MONITOREOS));
  const menu = useSelector(selectMenuState);
  const catalogos = useSelector(selectCatalogs);
  const [messageApi, contextHolder] = message.useMessage();
  const [folioCancelar, setFolioCancelar] = useState(null);
  const [monitoreoCancelar, setMonitoreoCancelar] = useState(null);
  const [successCancelar, setSuccessCancelar] = useState(false);
  const [downloadingExcel, setDownloadingExcel] = useState(false);
  const [disableBtnVali, setDisableBtnVali] = useState(false);
  const [loadingTable, setLoadingTable] = useState(false);
  const [refreshTableKey, setRefreshTableKey] = useState(0);
  const [pdfActa, setPdfActa] = useState(null);
  const [checkedListDescargas, setCheckedListDescargas] = useState([]);
  const [checkedListNotificar, setCheckedListNotificar] = useState([]);
  const [checkedListValidar, setCheckedListValidar] = useState([]);
  const [disableButtonNotificar, setDisableButtonNotificar] = useState(true);
  const [visibleModalNotificar, setVisibleModalNotificar] = useState(false);

  // MNI - Procesar todos
  const [procesarTodo, setProcesarTodo] = useState(false);

  const catalogosStore = {};
  catalogosStore.procesosEspe = procesosEspe;
  catalogosStore.estados = estados;
  catalogosStore.catBeneficiados = catalogos.data.beneficiados;
  catalogosStore.catMonitoreos = catMonitoreos;

  const { loading, data } = useSelector(selectMonitoreosInternetState);

  const allOptions = data;
  const checkAllOptionsDescargas =
    allOptions.length === checkedListDescargas.length && allOptions.length !== 0;
  const indeterminateDescargas =
    checkedListDescargas.length > 0 && checkedListDescargas.length < allOptions.length;

  const allOptionsNotificar = data.filter(
    (monitoreo) =>
      monitoreo.estatusCheck === 'Validado' && monitoreo.notificarPartido !== NOTIFICADO
  );
  const notificadosParcialmente = allOptionsNotificar.filter(
    (item) => item.notificarPartido === PARCIALMENTE_NOTIFICADO
  );
  const checkAllOptionsNotificar =
    allOptionsNotificar.length === checkedListNotificar.length && allOptionsNotificar.length !== 0;
  const indeterminateNotificar =
    (checkedListNotificar.length > 0 && checkedListNotificar.length < allOptionsNotificar.length) ||
    notificadosParcialmente?.length > 0;

  const allOptionsValidar = data.filter(
    (monitoreo) =>
      monitoreo.hallazgos && monitoreo.hallazgos.length > 0 && monitoreo.hallazgos[0].estatus === 2
  );
  const allOptionsValidados = data.filter(
    (monitoreo) =>
      monitoreo.hallazgos && monitoreo.hallazgos.length > 0 && monitoreo.hallazgos[0].estatus === 4
  );
  const checkAllOptionsValidar =
    allOptionsValidar.length === checkedListValidar.length && allOptionsValidar.length !== 0;
  const indeterminateValidar =
    checkedListValidar.length > 0 && checkedListValidar.length < allOptionsValidar.length;

  const tienePermisoValidar = getMenuPermissions(
    menu,
    NOMBRE_MENU_INTERNET,
    null,
    NOMBRE_MENU_PERMISO_VALIDAR
  );

  const tienePermisoEditar = getMenuPermissions(
    menu,
    NOMBRE_MENU_INTERNET,
    null,
    NOMBRE_MENU_PERMISO_EDITAR
  );

  const tienePermisoNotificar = getMenuPermissions(
    menu,
    NOMBRE_MENU_INTERNET,
    null,
    NOMBRE_MENU_PERMISO_NOTIFICAR
  );

  const showTotal = (total, range) => {
    if (total === 0) {
      setDisableBtnVali(true);
    }
    return `Mostrando del ${range[0]} al ${range[1]} de ${total} registros`;
  };

  const [pagination, setPagination] = useState({
    position: ['bottomRight'],
    showQuickJumper: true,
    size: 'small',
    pageSize: 10,
    current: 1,
    showTotal,
    total: 0,
    showSizeChanger: false
  });

  const [selectedRow, setSelectedRow] = useState(null);
  const applyFilter = useDebounce((fields) => setFilters(fields), DEBOUNCE_TIME_FILTER);
  const dispatch = useDispatch();

  const handleConfirmCancel = async (comments) => {
    const payload = {
      monitoreos: {
        toCancel: [
          {
            pkMonitoreo: monitoreoCancelar,
            idMonitoreo: monitoreoCancelar,
            motivoCancelacion: comments.motivo
          }
        ]
      }
    };
    const { success, response } = await dispatch(cancelMonitoring(payload));
    if (success && response?.data.code === 200) {
      // Se quita el monitoreo eliminado para que no se mantenga el check seleccionado en dado que esté seleccionado
      delete validar.current[monitoreoCancelar];

      setMonitoreoCancelar(null);
      setSuccessCancelar(true);
      dispatch(getMonitoreosInternet(pagination.current, pagination.pageSize));
    } else if (response?.causa !== undefined) {
      messageApi.error(response.causa);
    } else {
      messageApi.error(MensGrales.MAV1_2);
    }
  };

  const handleCancelMonitoring = (cancelData) => {
    setMonitoreoCancelar(cancelData);
  };

  const handleOpenModal = () => {
    setIsFormModalVisible(true);
  };

  const handleChangeFilter = ({ target }) => {
    const { value, name } = target;
    filtersRef.current[name] = value;
    applyFilter({ ...filtersRef.current });
  };

  const handleChangeDateFilter = (date) => {
    filtersRef.current.fechaRegistro = date;
    applyFilter({ ...filtersRef.current });
  };

  const handleChangeEntityFilter = (idEntidad) => {
    if (idEntidad === undefined) {
      filtersRef.current.idEstado = null;
      delete filtersRef.current[idEntidad];
    } else {
      filtersRef.current.idEstado = idEntidad;
    }
    applyFilter({ ...filtersRef.current });
  };

  const callAction = (clickedRow, actionType) => {
    const selectedDataRow = data.find((row) => row.folio === clickedRow.folio);
    if (actionType === 'view' || actionType === 'edit') {
      setIsFormModalVisible(true);
      setSelectedRow({ tableRow: selectedDataRow, actionType });
    }
  };

  const handleGetPdfActa = async (idMonitoreo, option, idHallazgo) => {
    const payload = {
      tipoMonitoreo: MONITOREOS_INTERNET,
      tipoActa: null,
      tipoDescarga: DOWNLOAD_TYPES.TESTIGOS.value,
      listaIdMonitoreos: [idMonitoreo]
    };
    try {
      const { success, response } = await dispatch(getPdfActa(payload));

      const { archivo } = response.data;
      if (success) {
        setPdfActa(archivo);

        if (option === 'eyeOutlined') {
          setIsModalPdfOpen(true);
          setIsMonitoreoId(idMonitoreo);
          setIsHallazgoId(idHallazgo);
        }

        if (option === 'downloadOutlined') {
          DescargaPDF(archivo, PDF_INTERNET, idMonitoreo, idHallazgo);
        }
      }
    } catch (error) {
      messageApi.error('Error al obtener el PDF', 3);
    }
  };

  const filter = (columnName, lblColumn) => (
    <label htmlFor={columnName}>
      {lblColumn}
      <Input
        id={columnName}
        placeholder="Filtrar"
        name={columnName}
        key={columnName}
        onChange={handleChangeFilter}
      />
    </label>
  );

  const filterDate = (columnName, lblColumn) => (
    <label htmlFor={columnName}>
      {lblColumn}
      <DatePicker
        id={columnName}
        name={columnName}
        key={columnName}
        placeholder="Filtrar"
        style={{ width: '100%' }}
        allowClear
        onChange={handleChangeDateFilter}
        format={DATE_FORMAT_DATE_PICKER}
      />
    </label>
  );

  const filterEntity = (columnName, lblColumn) => (
    <label htmlFor={columnName}>
      {lblColumn}
      <Select
        placeholder="Filtrar"
        options={estados}
        onChange={handleChangeEntityFilter}
        style={{ width: '100%' }}
        allowClear
        fieldNames={{
          value: 'idEstado',
          label: 'nombreEstado'
        }}
      />
    </label>
  );

  const checkBoxEstatusMonitoreo = (row) => {
    let enableCheckBox = false;
    if (row.estatusCheck !== 'Validado' || row.notificarPartido === NOTIFICADO) {
      enableCheckBox = true;
    }
    return enableCheckBox;
  };

  const onChange = (row, checked, optionType) => {
    switch (optionType) {
      case 'Descargas':
        if (checked) {
          // Si está marcado, agregar el row al checkedList
          setCheckedListDescargas((prevCheckedList) => [...prevCheckedList, row]);
        } else {
          // Si está desmarcado, filtrar el row fuera del checkedList
          setCheckedListDescargas((prevCheckedList) =>
            prevCheckedList.filter((item) => item.idForDescarga !== row.idForDescarga)
          );
        }
        break;
      case 'Notificar':
        if (checked) {
          // Si está marcado, agregar el row al checkedList
          setCheckedListNotificar((prevCheckedList) => [...prevCheckedList, row]);
        } else {
          // Si está desmarcado, filtrar el row fuera del checkedList
          setCheckedListNotificar((prevCheckedList) =>
            prevCheckedList.filter((item) => item.idForNotificar !== row.idForNotificar)
          );
        }
        break;
      default:
        if (checked) {
          // Si está marcado, agregar el row al checkedList
          setCheckedListValidar((prevCheckedList) => [
            ...prevCheckedList,
            { ...row, esNuevo: true } // Se agrega el campo `esNuevo`
          ]);
        } else {
          // Si está desmarcado, filtrar el row fuera del checkedList
          setCheckedListValidar((prevCheckedList) =>
            prevCheckedList.filter((item) => item.idForValidar !== row.idForValidar)
          );
        }
    }
  };

  const handleSetProcesarTodo = (valor) => {
    try {
      setProcesarTodo(valor);
      if (onProcesarTodoChange) {
        onProcesarTodoChange(valor);
      }
    } catch (error) {
      console.log(procesarTodo); // Eliminar cuando se reactive la variable
      console.log('Error: ', error);
    }
  };

  const onCheckAllChange = (e, optionType) => {
    const newSeleccion = {};
    const newNotificar = {};
    const newValidar = {};
    switch (optionType) {
      case 'Descargas':
        if (e.target.checked) {
          allOptions.forEach((item) => {
            newSeleccion[item.idForDescarga] = true;
          });
          // eslint-disable-next-line no-param-reassign
          seleccion.current = newSeleccion;
          handleSetProcesarTodo(true);
        } else {
          allOptions.forEach((item) => {
            newSeleccion[item.idForDescarga] = false;
          });
          // eslint-disable-next-line no-param-reassign
          seleccion.current = newSeleccion;
          handleSetProcesarTodo(false);
        }
        setCheckedListDescargas(e.target.checked ? allOptions : []);
        break;
      case 'Notificar':
        if (e.target.checked) {
          allOptionsNotificar.forEach((item) => {
            newNotificar[item.idForNotificar] = true;
          });
          notificadosParcialmente.forEach((item) => {
            newNotificar[item.idForNotificar] = true;
          });
        } else {
          allOptionsNotificar.forEach((item) => {
            newSeleccion[item.idForNotificar] = false;
          });
          notificadosParcialmente.forEach((item) => {
            newNotificar[item.idForNotificar] = false;
          });
        }
        notificar.current = newNotificar;
        setCheckedListNotificar(e.target.checked ? allOptionsNotificar : []);
        break;
      default:
        allOptionsValidados.forEach((item) => {
          newValidar[item.idMonitoreo] = true;
        });

        if (e.target.checked) {
          allOptionsValidar.forEach((item) => {
            newValidar[item.idMonitoreo] = true;
          });
          validar.current = newValidar;
        } else {
          allOptionsValidar.forEach((item) => {
            newValidar[item.idMonitoreo] = false;
          });
          validar.current = newValidar;
        }
        setCheckedListValidar(e.target.checked ? allOptionsValidar : []);
    }
  };

  const checkAll = (columnName, lblColumn) => (
    <label className="checkAll" htmlFor={columnName}>
      {lblColumn}
      <Checkbox
        className="checkboxAll"
        indeterminate={indeterminateDescargas}
        onChange={(e) => onCheckAllChange(e, 'Descargas')}
        checked={checkAllOptionsDescargas}
        disabled={allOptions.length === 0}
      />
    </label>
  );

  const checkAllNotificar = (columName, lblColumn) => (
    <label className="checkAll" htmlFor={columName}>
      {lblColumn}
      <Checkbox
        className="checkboxAll"
        indeterminate={indeterminateNotificar}
        onChange={(e) => onCheckAllChange(e, 'Notificar')}
        checked={checkAllOptionsNotificar}
        disabled={allOptionsNotificar.length === 0}
      />
    </label>
  );

  const checkAllValidar = (columnName, lblColumn) => (
    <label className="checkAll" htmlFor={columnName}>
      {lblColumn}
      <Checkbox
        className="checkboxAll"
        indeterminate={indeterminateValidar}
        onChange={(e) => onCheckAllChange(e, 'Validar')}
        checked={checkAllOptionsValidar}
        disabled={allOptionsValidar.length === 0}
      />
    </label>
  );

  const renderCheckboxDescarga = (_, row) => (
    <Checkbox
      checked={!!seleccion.current[row.idForDescarga]}
      key={row.idForDescarga}
      onChange={({ target }) => {
        const { current } = seleccion;
        current[row.idForDescarga] = target.checked;
        onChange(row, target.checked, 'Descargas');
      }}
    />
  );

  let checkVal = [];
  let monChecked = null;

  const renderCheckboxValidacion = (_, row) => {
    if (tienePermisoValidar || tienePermisoEditar) {
      return (
        <Checkbox
          checked={!!validar.current[row.idMonitoreo] || row.hallazgos[0].estatus === 4}
          key={row.idMonitoreo}
          onChange={({ target }) => {
            const { checked } = target;
            const { current } = validar;
            current[row.idMonitoreo] = target.checked;
            onChange(row, target.checked, 'Validar');
            if (checked) {
              checkVal.push(row.idMonitoreo);
              monChecked = row;
            } else {
              checkVal = checkVal.filter((id) => id !== row.idMonitoreo);
              monChecked = null;
            }
          }}
          disabled={
            (row.hallazgos && row.hallazgos.length > 0 && row.hallazgos[0].estatus === 4) ||
            row.estatusMonitoreo === 3
          }
        />
      );
    }
    return <Checkbox disabled />;
  };

  const renderCheckboxNotificar = (_, row) => {
    if (tienePermisoEditar || tienePermisoValidar) {
      return (
        <Checkbox
          checked={
            !!notificar.current[row.idForNotificar] ||
            row.notificarPartido === PARCIALMENTE_NOTIFICADO ||
            row.notificarPartido === NOTIFICADO
          }
          disabled={checkBoxEstatusMonitoreo(row)}
          key={row.idFolio}
          onChange={({ target }) => {
            // const { checked } = target;
            const { current } = notificar;
            current[row.idForNotificar] = target.checked;
            onChange(row, target.checked, 'Notificar');
            // if (checked) {
            //   checkVal.push(row.idForNotificar);
            //   monChecked = row;
            // } else {
            //   checkVal = checkVal.filter((id) => id !== row.idForNotificar);
            //   monChecked = null;
            // }
          }}
        />
      );
    }
    return <Checkbox disabled />;
  };

  const onValidarHallazgos = async () => {
    // const monitoreosSeleccionados = checkVal;
    const monitoreosSeleccionados = checkedListValidar.map((item) => item.idMonitoreo);
    if (monitoreosSeleccionados.length === 0) {
      message.error('Debes seleccionar al menos un monitoreo para validar.');
      return;
    }
    if (monitoreosSeleccionados !== null) {
      setDisableBtnVali(true);
      setLoadingTable(true);
      const request = {
        token: '',
        monitoreos: {
          toDeValidate: [],
          toValidate: []
        }
      };
      for (let j = 0; j < monitoreosSeleccionados.length; j += 1) {
        request.monitoreos.toValidate.push({
          pkMonitoreo: monitoreosSeleccionados[j],
          idMonitoreo: monitoreosSeleccionados[j]
        });
      }
      const { success, response } = await dispatch(validarHallazgosByMoni(request));
      if (success && response?.data.code === 200) {
        setTimeout(async () => {
          if (monChecked !== null) {
            monChecked.hallazgos[0].estatus = 4;
          }

          const monitoreoValidar = checkedListValidar.filter((x) => x.esNuevo === true);

          // console.log('monitoreoValidar: ', monitoreoValidar);

          for (let i = 0; i < monitoreoValidar.length; i += 1) {
            // MNI - Llamado a la generación de PDF's al momento de validar
            const monitoreoPDF = [
              {
                idMonitoreo: monitoreoValidar[i].idMonitoreo,
                idTipoMonitoreo: 3,
                tiposActa: [{ id: 5 }]
              }
            ];

            // Se genera PDF una vez que se han almacenado las Muestras
            // eslint-disable-next-line no-await-in-loop
            await generarPDFMonitoreosValidacion(monitoreoPDF);
          }

          message.success('Los monitoreos se validaron correctamente');
          setRefreshTableKey((prevKey) => prevKey + 1);
          setLoadingTable(false);
        }, 500);
      } else if (response?.causa !== undefined) {
        messageApi.error(response.causa);
        setLoadingTable(false);
      } else {
        messageApi.error(MensGrales.MAV1_2);
        setLoadingTable(false);
      }
      setDisableBtnVali(false);
    }
  };

  const renderActions = (value, row, index) => (
    <div className="actions-container">
      <Tooltip
        title="Consultar"
        className="tooltip-acciones btn-deleteoutlined"
        placement="topLeft">
        <Button
          type="primary"
          onClick={() => {
            messageApi.open({
              content: <Spin />
            });
            const { idMonitoreo, idHallazgo } = row.hallazgos[0];
            handleGetPdfActa(idMonitoreo, 'eyeOutlined', idHallazgo);
          }}
          icon={<EyeOutlined />}
          ghost
        />
      </Tooltip>
      {getMenuPermissions(menu, NOMBRE_MENU_INTERNET, null, NOMBRE_MENU_PERMISO_EDITAR) && (
        <Tooltip title="Editar" className="tooltip-acciones btn-deleteoutlined" placement="topLeft">
          <Button
            type="primary"
            onClick={() => callAction({ folio: row.folio }, 'edit', index)}
            icon={<EditOutlined />}
            ghost
          />
        </Tooltip>
      )}
      <Tooltip
        title="Descargar"
        className="tooltip-acciones btn-deleteoutlined"
        placement="topLeft">
        <Button
          type="primary"
          onClick={() => {
            messageApi.open({
              content: <Spin />
            });
            const { idMonitoreo, idHallazgo } = row.hallazgos[0];
            handleGetPdfActa(idMonitoreo, 'downloadOutlined', idHallazgo);
          }}
          icon={<DownloadOutlined />}
          ghost
        />
      </Tooltip>
      {(getMenuPermissions(menu, NOMBRE_MENU_INTERNET, null, NOMBRE_MENU_PERMISO_ELIMINAR) ||
        tienePermisoEditar) &&
        row.estatusMonitoreo !== 3 && (
          <Tooltip
            title="Cancelar"
            className="tooltip-acciones btn-deleteoutlined"
            placement="topLeft"
            arrow={{ pointAtCenter: true }}>
            <Button
              shape="circle"
              onClick={() => {
                handleCancelMonitoring(row.idMonitoreo);
                setFolioCancelar(row.folio);
              }}
              icon={<CloseCircleOutlined className="icons-tbl-users" />}
            />
          </Tooltip>
        )}
    </div>
  );

  const columns = [
    {
      title: filter('folio', 'Folio de monitoreo'),
      dataIndex: 'folio',
      width: '15%',
      key: 'folio'
    },
    {
      title: filterDate('fechaRegistro', 'Fecha de registro'),
      dataIndex: 'fechaRegistro',
      render: (d) => d.format(DATE_FORMAT_COLUMN_TABLE),
      width: '16%'
    },
    {
      title: filter('monitor', 'Monitorista'),
      dataIndex: 'monitor',
      align: 'center',
      width: '17%'
    },
    {
      title: filterEntity('idEstado', 'Entidad'),
      dataIndex: 'estado',
      align: 'center',
      width: '10%'
    },
    {
      title: filter('estatus', 'Estatus'),
      dataIndex: 'estatus',
      align: 'center',
      width: '10%'
    },
    {
      title: checkAllValidar('validado', 'Check de validación'),
      dataIndex: 'validado',
      align: 'center',
      render: renderCheckboxValidacion,
      width: '8%'
    },
    {
      title: checkAllNotificar('aNotificar', 'Notificar a partido'),
      dataIndex: 'aNotificar',
      align: 'center',
      render: renderCheckboxNotificar,
      width: '8%'
    },
    {
      title: checkAll('descargado', 'Check de descarga'),
      dataIndex: 'descargado',
      align: 'center',
      render: renderCheckboxDescarga,
      width: '8%'
    },
    {
      title: 'Acciones',
      dataIndex: 'actions',
      align: 'center',
      width: '8%',
      key: 'actions',
      render: renderActions
    }
  ];

  const handleDownloadExcel = async () => {
    setDownloadingExcel(true);
    const { success, response } = await dispatch(
      downloadExcelMonitoreos({ tipoMonitoreo: MONITOREOS_INTERNET })
    );
    if (response !== null && response !== undefined && success) {
      if (response.data.code === 200) {
        if (response.data.excel64) {
          const url = window.URL.createObjectURL(
            base64toBlob(response.data.excel64.base64, response.data.excel64.tipo)
          );
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', response.data.excel64.nombre);
          link.click();
          setDownloadingExcel(false);
        }
      }
    }
    setDownloadingExcel(false);
  };

  const handleChangePageSize = (pageSize) => {
    setPagination((prevPagination) => ({ ...prevPagination, pageSize, current: 1 }));
  };

  const filteredList = useMemo(() => {
    const { fechaFinal, fechaInicio, folioDesde, folioHasta, idProcesoGral, idProcesoEspecifico } =
      mainFilters;
    const formatDateFechaFinal = dayjs(fechaFinal, 'YYYYMMDDHHmmss')
      .locale('es')
      .format(REGULAR_DATE_FORMAT);
    const formatDateFechaInicio = dayjs(fechaInicio, 'YYYYMMDDHHmmss')
      .locale('es')
      .format(REGULAR_DATE_FORMAT);
    const filteredData = data.filter((row) => {
      const folio = getFolioNumber(row.folio, PREFIX_INTERNET);
      const fechaFormatRow = dayjs(row.fechaRegistro, 'YYYYMMDDHHmmss')
        .locale('es')
        .format(REGULAR_DATE_FORMAT);
      if (folioDesde && folio < folioDesde) return false;
      if (folioHasta && folio > folioHasta) return false;
      if (idProcesoGral && row.idProcesoGral !== idProcesoGral) return false;
      if (idProcesoEspecifico && row.hallazgos?.[0]?.idProcesoEspecifico !== idProcesoEspecifico)
        return false;
      if (fechaFinal && formatDateFechaFinal < fechaFormatRow) return false;
      if (fechaInicio && formatDateFechaInicio > fechaFormatRow) return false;
      return true;
    });
    return filteredData;
  }, [data, mainFilters]);

  const allowedColumns = useMemo(() => {
    if (!getMenuPermissions(menu, NOMBRE_MENU_INTERNET, null, NOMBRE_MENU_PERMISO_NOTIFICAR)) {
      return columns
        .map((column) =>
          column.dataIndex.includes('aNotificar') || column.dataIndex.includes('validado')
            ? null
            : column
        )
        .filter((column) => column !== null);
    }
    return columns;
  }, [checkedListNotificar, checkedListDescargas, checkedListValidar]);

  const dataList = useMemo(() => {
    // setCheckedListNotificar([]);
    setCheckedListValidar([]);
    const listaFiltrada = filterList(filteredList, filters);

    // Obtiene la descripción del estatus según el valor del estatus del hallazgo
    listaFiltrada.forEach((element) => {
      // eslint-disable-next-line no-param-reassign
      element.estatus = [HALLAZGO_CANCELADO, HALLAZGO_NO_VALIDADO, HALLAZGO_VALIDADO].find(
        (e) => e.value === element.idEstatusCheck
      )?.label;
    });

    return listaFiltrada;
  }, [filteredList, filters]);

  // useEffect(() => {
  //   const seleccionN = {};
  //   const seleccionV = {};
  //   checkedListNotificar.forEach((item) => {
  //     seleccionN[item.idForNotificar] = true;
  //   });
  //   // Por definición de onCheckAllChange, basta con enviar el objeto eNotificar para restablecer los valores del check Notificar
  //   const eNotificar = { target: { checked: false } };
  //   onCheckAllChange(eNotificar, 'Notificar');

  //   validar.current = seleccionV;
  // }, [dataList]);

  const getDataInternet = async () => {
    try {
      const { success, totalInternet } = await dispatch(
        getMonitoreosInternet(pagination.current, pagination.pageSize)
      );
      if (success && totalInternet > 0) {
        setPagination((prev) => ({
          ...prev,
          total: totalInternet
        }));
        // Cada que cambia la paginación reiniciamos los check a false
        const eNotificar = { target: { checked: false } };
        onCheckAllChange(eNotificar, 'Notificar');
        onCheckAllChange(eNotificar, 'Descargas');
        onCheckAllChange(eNotificar, 'Validar');
      }
    } catch (error) {
      console.log(error);
    }
  };

  const onClickButtonNotificarOGenerar = () => {
    notificadosParcialmente.forEach((item) => {
      notificar.current[item.idForNotificar] = true;
    });
    // console.log('notificar', notificar);
  };

  const handleCancel = () => {
    setIsFormModalVisible(false); // Cerramos el modal
    setSelectedRow(null); // Quitamos los datos iniciales para el caso de edicion
  };

  const handleCloseModal = () => {
    setIsFormModalVisible(false); // Cerramos el modal
    setSelectedRow(null); // Quitamos los datos iniciales para el caso de edicion
    getDataInternet();
  };

  useEffect(() => {
    // console.log('data1: ' , data);
    getDataInternet();
  }, [refreshTableKey, pagination.current, pagination.pageSize]);

  useEffect(() => {
    if (checkedListNotificar?.length === 0 || notificadosParcialmente?.length === 0) {
      setDisableButtonNotificar(true);
    }
    if (checkedListNotificar?.length > 0 || notificadosParcialmente?.length > 0) {
      setDisableButtonNotificar(false);
    }
  }, [checkedListNotificar, checkedListValidar]);

  return (
    <div className="tabla-monitoreo">
      <ModalFormularioMonitoreo
        visible={isFormModalVisible}
        onClose={handleCloseModal}
        initialData={selectedRow}
        pagina={pagination.current}
        pageSize={pagination.pageSize}
        onCancel={handleCancel}
      />
      <ModalNotificarPartido
        visible={visibleModalNotificar}
        seleccion={notificar}
        tipo={TIPO_INTERNET}
        onClose={() => setVisibleModalNotificar(false)}
        getMonitoreos={getDataInternet}
      />
      <ModalPdf
        open={isModalPdfOpen}
        pdfActa={pdfActa}
        tipoActa={PDF_INTERNET}
        callback={() => setIsModalPdfOpen(false)}
        idActa={isHallazgoId}
        idMonitoreo={isMonitoreoId}
        destroyOnClose
      />
      <div>
        <CancelModalMonitoring
          open={monitoreoCancelar}
          title={`¿Estás seguro de cancelar el monitoreo ${folioCancelar}?`}
          cancelConfirm={handleConfirmCancel}
          handleCerrar={() => {
            setMonitoreoCancelar(null);
            setSuccessCancelar(false);
          }}
          openSuccess={successCancelar}
        />
      </div>
      <div className="table-header">
        <div>
          <SelectTamanoPagina
            value={pagination.pageSize}
            onChange={handleChangePageSize}
            disableBottomExcel={downloadingExcel}
            onClick={handleDownloadExcel}
          />
        </div>
        {getMenuPermissions(menu, NOMBRE_MENU_INTERNET, null, NOMBRE_MENU_PERMISO_CAPTURAR) && (
          <Button text="Agregar nuevo monitoreo" type="primary" onClick={handleOpenModal} />
        )}
      </div>
      {contextHolder}
      <Table
        key={refreshTableKey}
        bordered={false}
        columns={allowedColumns}
        dataSource={dataList}
        pagination={{
          ...pagination,
          onChange: (page, pageSize) => {
            setPagination((prev) => ({
              ...prev,
              current: page,
              pageSize: pageSize || prev.pageSize
            }));
          }
        }}
        loading={loading || loadingTable}
      />
      <div className="contenedorBtns">
        {tienePermisoNotificar && (
          <>
            <div className="btnNotificar">
              <Button
                onClick={() => {
                  onClickButtonNotificarOGenerar();
                  setVisibleModalNotificar(true);
                }}
                size="large"
                type="primary"
                text="Enviar notificación"
                icon={<BellOutlined />}
                disabled={disableButtonNotificar || loading}
              />
            </div>
            <div className="btnGenerar">
              <DescripcionEnlacesModal
                seleccion={notificar}
                tipoMonitoreo={MONITOREOS_INTERNET}
                tipoActa={null}
                disabledButton={disableButtonNotificar || loading}
                onUpdateSeleccion={onClickButtonNotificarOGenerar}
              />
            </div>
          </>
        )}
        {tienePermisoValidar && (
          <div className="btnValidar">
            <Button
              type="primary"
              text="Validar monitoreos"
              size="large"
              loading={loading}
              disabled={disableBtnVali}
              onClick={onValidarHallazgos}
            />
          </div>
        )}
      </div>
    </div>
  );
};

TablaMonitoreo.propTypes = {
  mainFilters: PropTypes.shape({
    fechaFinal: PropTypes.shape({}),
    fechaInicio: PropTypes.shape({}),
    folioDesde: PropTypes.number,
    folioHasta: PropTypes.number,
    idProcesoGral: PropTypes.number,
    idProcesoEspecifico: PropTypes.number
  }).isRequired,
  seleccion: PropTypes.shape({
    current: PropTypes.shape({})
  }).isRequired,
  onProcesarTodoChange: PropTypes.func.isRequired
};
